import styled from 'styled-components';
import { Input } from 'antd';

export const CommentTextArea = styled(Input.TextArea)`
	&& textarea {
		height: 7.125rem;
		padding: 0.5rem;
		border: 1px solid ${({ theme }) => theme.palette.secondary[150]};
		border-radius: 0.25rem;
		color: ${({ theme }) => theme.palette.secondary[400]};
		font-size: 1rem;
		line-height: 1.5rem;
		resize: none;
	}

	&& textarea::placeholder {
		color: ${({ theme }) => theme.palette.secondary[250]};
	}

	&&::after {
		margin-top: 0.5rem;
		color: ${({ theme }) => theme.palette.secondary[250]};
		font-size: 0.875rem;
		line-height: 1rem;
	}
`;
